"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProps;
var _react = require("react");
var _PropsContext = require("../context/PropsContext");
var _lodash = _interopRequireDefault(require("lodash.get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {string=} propPath the path for property of the widget you want to get
 * @param {*=} defaultValue  the value that is returned
 * if it couldn't find the property using the path
 * @returns the widget properties
 */
function useProps(propPath, defaultValue) {
  var _useContext;
  const widgetProps = (_useContext = (0, _react.useContext)(_PropsContext.PropsContext)) !== null && _useContext !== void 0 ? _useContext : {};
  return propPath ? (0, _lodash.default)(widgetProps, propPath, defaultValue) : widgetProps;
}